import { useState } from 'react'
import type { FormEvent } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

function SignupPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const inviteToken = searchParams.get('platform_invite')

  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()

    setError('')
    setLoading(true)

    try {
      const response = await fetch('/api/auth/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          full_name: fullName.trim(),
          email: email.trim(),
          password,
          ...(inviteToken ? { platform_invite_token: inviteToken } : {}),
        }),
      })

      const data = await response.json()

      if (!response.ok) {
        if (typeof data.detail === 'string') {
          setError(data.detail)
        } else {
          setError('Unable to create account.')
        }

        return
      }

      localStorage.setItem(
        'aad_verification_email',
        email.trim(),
      )

      navigate('/verify-email')
    } catch {
      setError(
        'Unable to connect to the server. Please try again.',
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <main>
      <section>
        <h1>Create your AAD Business App account</h1>

        <p>
          Start managing your business with AAD Digital Technology.
        </p>

        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="fullName">
              Full name
            </label>

            <input
              id="fullName"
              name="fullName"
              type="text"
              value={fullName}
              onChange={(event) =>
                setFullName(event.target.value)
              }
              autoComplete="name"
              required
            />
          </div>

          <div>
            <label htmlFor="email">
              Email address
            </label>

            <input
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={(event) =>
                setEmail(event.target.value)
              }
              autoComplete="email"
              required
            />
          </div>

          <div>
            <label htmlFor="password">
              Password
            </label>

            <input
              id="password"
              name="password"
              type="password"
              value={password}
              onChange={(event) =>
                setPassword(event.target.value)
              }
              autoComplete="new-password"
              minLength={8}
              required
            />
          </div>

          {error && (
            <p role="alert">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
          >
            {loading
              ? 'Creating account...'
              : 'Create account'}
          </button>
        </form>

        <button
          type="button"
          onClick={() => navigate(inviteToken ? `/login?platform_invite=${encodeURIComponent(inviteToken)}` : '/login')}
        >
          Already have an account? Sign in
        </button>
      </section>
    </main>
  )
}

export default SignupPage
